<template>
  <b-card
    class="push-preview"
    :class="pushClass"
    no-body
  >
    <b-card-header>
      <push-link
        :pushId="push.id"
      />

      <template v-if="forTest">[for test]</template>
    </b-card-header>

    <b-card-body>
      <table class="props-compact mb-2">
        <tr>
          <th>Created</th>
          <td>{{push.ctime | getMomentStr}}</td>
        </tr>
        <tr>
          <th>Status</th>
          <td>
            <span
              :class="statusClass"
            >
              {{status | getPushStatusName}}
            </span>
            <template v-if="isActive">
              ({{getDonePercentStr}})
            </template>
          </td>
        </tr>
        <tr v-if="hasInfo">
          <th>Info</th>
          <td>{{push.info}}</td>
        </tr>
        <tr v-if="hasMaxVersion">
          <th>Max version</th>
          <td>{{maxVersionStr}}</td>
        </tr>
        <tr v-if="hasPlatforms">
          <th>Platforms</th>
          <td>{{platformsStr}}</td>
        </tr>
        <tr v-if="hasPlayersIds">
          <th>Players</th>
          <td>
            <player-links :playerIds="push.playersIds"/>
          </td>
        </tr>
        <tr v-if="isIncoming">
          <th>
            Expected start
          </th>
          <td>
            {{push.stime | getMomentStr}}
          </td>
        </tr>
        <tr v-if="hasStatInfo">
          <th>
            Total<br>
            Sent<br>
            Fails
          </th>
          <td>
            <div class="push-preview-stat">
              {{push.total | getFormattedNumber}}<br>
              {{push.sent | getFormattedNumber}}<br>
              {{push.fails | getFormattedNumber}}
            </div>
          </td>
        </tr>
      </table>
      <b-card-text>
        {{push.title}}
      </b-card-text>
      <b-card-text>
        {{push.message}}
      </b-card-text>
    </b-card-body>
  </b-card>
</template>

<script>
import PushLink from './PushLink.vue';
import PlayerLinks from './PlayerLinks.vue';

import { getPushStatus         } from '../model/push.js';
import { getPushStatusName     } from '../model/push.js';
import { hasPushInfo           } from '../model/push.js';
import { hasPushMaxVersion     } from '../model/push.js';
import { getPushMaxVersionStr  } from '../model/push.js';
import { hasPushPlatforms      } from '../model/push.js';
import { getPushPlatformsStr   } from '../model/push.js';
import { hasPushPlayersIds     } from '../model/push.js';
import { hasPushStatInfo       } from '../model/push.js';
import { isPushIncoming        } from '../model/push.js';
import { isPushActive          } from '../model/push.js';
import { isPushFinished        } from '../model/push.js';
import { PUSH_STATUS_INACTIVE  } from '../model/push.js';
import { getPushStatusClass    } from '../model/push.js';
import { getPushDonePercentStr } from '../model/push.js';


export default {
  name: 'PushPreview',

  components: {
    PushLink,
    PlayerLinks,
  },

  props: {
    push: {
      type: Object,
      required: true,
    },
  },

  computed: {
    /** @returns {boolean} */
    hasInfo() {
      return hasPushInfo(this.push);
    },

    /** @returns {boolean} */
    hasMaxVersion() {
      return hasPushMaxVersion(this.push);
    },

    /** @returns {string} */
    maxVersionStr() {
      return getPushMaxVersionStr(this.push);
    },

    /** @returns {boolean} */
    hasPlatforms() {
      return hasPushPlatforms(this.push);
    },

    /** @returns {string} */
    platformsStr() {
      return getPushPlatformsStr(this.push);
    },

    /** @returns {boolean} */
    hasPlayersIds() {
      return hasPushPlayersIds(this.push);
    },

    status() {
      return getPushStatus(this.push);
    },

    pushClass() {
      return getPushClass(this.push);
    },

    statusClass() {
      return getPushStatusClass(this.push);
    },

    /** @returns {boolean} */
    hasStatInfo() {
      return hasPushStatInfo(this.push);
    },

    /** @returns {boolean} */
    isIncoming() {
      return isPushIncoming(this.push);
    },

    /** @returns {boolean} */
    isActive() {
      return isPushActive(this.push);
    },

    /** @returns {string} */
    getDonePercentStr() {
      return getPushDonePercentStr(this.push);
    },

    /** @returns {boolean} */
    forTest() {
      const forTest = this.push.forTest;
      if(forTest === undefined) {
        return false;
      }

      return forTest;
    },
  },

  filters: {
    getPushStatusName,
  },
};

function getPushClass(push) {
  if(isPushFinished(push)) {
    if(push.fails === 0)
      return 'push-preview-success';
    else
      return 'push-preview-warning';
  }

  if(push.status === PUSH_STATUS_INACTIVE)
    return 'push-preview-inactive';

  // PUSH_STATUS_INCOMING
  // PUSH_STATUS_ACTIVE
  return '';
}
</script>

<style scoped>
  .push-preview .card-body,
  .push-preview .card-header {
    padding: 10px;
  }

  .push-preview-inactive {
    border-color: #dee2e6;
    background-color:rgba(0, 0, 0, 0.075);
  }

  .push-preview-success {
    border-color: #8fd19e;
    background-color: #c3e6cb;
  }

  .push-preview-warning {
    border-color: #ffdf7e;
    background-color: #ffeeba;

    /*border-color: #ffcf44;*/
    /*background-color: #ffdd7c;*/
    /*background-color: #ffeaaf;*/
  }

  .push-preview-stat {
    display: inline-block;
    text-align: right;
  }
</style>
